// ©2024 Austin App House. All rights reserved.
import React from 'react';
import DashboardIcon from '../../../dashboard/icons/DashboardIcon';

const ToolsElement = ({
  label, deleteTools, title,
  className = 'tools-element', deleteIconColor = '#1e2f41',
  labelClassName = '',
}) => (
  <div className={`flex-grow-0 text-in-one-line flex-box align-items-center ${className}`} title={title}>
    <span className={`no-margins ${labelClassName}`}>{label}</span>
    {
      deleteTools
        ? (
          <button
            type="button"
            className="row-action-btn row-action-btn--danger row-action-btn--compact"
            onClick={deleteTools}
            aria-label={`remove ${label}`}
            title={`Remove ${label}`}
          >
            <DashboardIcon name="close" size={12} strokeWidth="2" />
          </button>
        )
        : null
    }
  </div>
);

export default ToolsElement;
